import { creationComponentProps } from "../../../pages/calls/stepsConfig";
import Editor from "../../Editor";

function Creator({ content, setData }: creationComponentProps) {
  return <Editor content={content!} onChange={(data) => setData(data)} />;
}

export default Creator;
